import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserMilestoneEntry } from '../UserMilestoneEntry';
import { ValidatorUtil } from 'src/app/shared/ValidatorUtil';

@Component({
  selector: 'digires-user-milestone-entry',
  templateUrl: './user-milestone-entry.component.html',
  styleUrls: ['./user-milestone-entry.component.scss'],
})
export class UserMilestoneEntryComponent {
  @Output() onDelete: EventEmitter<void> = new EventEmitter<void>();
  @Input() data: UserMilestoneEntry;
  @Input() readOnly: boolean;

  readonly ValidatorUtil = ValidatorUtil;

  isDirty(formCtrlName: string): boolean {
    return this.data.initial[formCtrlName] !== this.data.fg.value[formCtrlName];
  }
}
